// extracted by mini-css-extract-plugin
export default {"container":"Sider_container__2dvlZ","!item":"Sider_!item__wy5KE","item":"Sider_item__xW8jP","itemBig":"Sider_itemBig__96neD"};